import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  body {
    @media screen {
      background-color: ${props => props.theme.colors.semantic.surface.page};
    }
    font-family: 'Nunito Sans', sans-serif;
    display: flex;

    zoom: reset;
    zoom: 100%;
  }

  #root {
    width: 100%;
  }
`;
